module.exports = __webpack_public_path__ + "static/media/act_quicr_logo.6c763c86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/act_quicr_logo.png
// module id = 162
// module chunks = 0